import css from 'styled-jsx/css';

const styles = css`:root {
    /* @TODO get a hold of/unify these colors...
       tell design to stop giving us a new color palatte
       with each new design...
    */

    /* New II Design Pattern - Introduced 11-12-2019 */
    /* TODO: --grey-800 is the color for primary text and should be used throughout the entire application */
}
:root {

    /* Margin and padding should be in multiples of 8 (i.e.---8, 16, 24) */

    /* New II Design Pattern - Introduced 11-12-2019 */
}
:root {

    /* New II Design Pattern - Introduced 11-12-2019 */
}
/* @import '@trp-beacon-ui-kit/foundation/style-tokens/css/variables.css'; */
.methodology-wrapper {
    display: inline-block;
    text-align: right;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    color: #3b4b59;
    float: right;
}
.methodology-title img {
    padding-right: 8px;
    margin-top: -2px;
}
.methodology-title p {
    float: right;
    margin-top: -3px;
    margin-bottom: 0;
}
.methodology-btn {
    text-decoration: none;
    font-weight: bold;
    color: #006894;
    padding: 2px;
    border: 2px solid transparent;
}
.methodology-btn:focus {
    border: 2px solid #000000;
    border-radius: 2px;
}
/* MODAL STYLES */
ul {
    margin-left: 20px;
}
.methodology-modal-wrapper {
    text-align: left;
    margin: calc(8px * 4) calc(8px * 6);
    color: #2d3940;
}
.close-btn-row {
    text-align: right;
    margin-bottom: 8px;
}
.modal-title {
    font-size: 32px;
    font-weight: normal;
    line-height: 44px;
    margin: 0;
}
.modal-content div {
    margin-bottom: calc(8px * 2);
    font-size: calc(8px * 2);
    line-height: 24px;
}
.modal-content p {
    margin-bottom: calc(8px * 2);
    font-size: calc(8px * 2);
    line-height: 24px;
}
.modal-content p:first-child {
    padding: 0;
    margin-top: 8px;
    margin-bottom: calc(8px * 3);
}
.modal-content ul {
    display: block;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: calc(8px * 2);
    padding: 0;
}
.modal-content-title {
    display: block;
    font-weight: bold;
    font-size: 20px;
    margin-bottom: calc(8px * 2);
    padding: 0;
}
.no-padding {
    margin-bottom: 0;
}
@media (max-width: 720px) {
    .methodology-wrapper {
        margin: calc(8px * 2) auto;
        text-align: left;
        float: none;
    }

    .methodology-title img {
        margin-top: 0;
        float: left;
    }
    .methodology-title p {
        float: none;
    }
}
`;

export default styles;